import axios from 'axios';
import * as types from '../mutation-types'
import {reportAxiosError} from "../../helpers";


const state = {

    accountPlan: null,
    plans: [],

};

const getters = {

    accountPlan: state => state.accountPlan,
    all: state => state.plans,

};

const actions = {

    load ({ commit, state, rootGetters }, payload) {
        if((!payload || typeof payload.force === 'undefined' || !payload.force) && state.plans.length > 0) {
            return;
        }


        return this.dispatch('countries/loadGeoIPCountry')
            .then(() => {

                let country = rootGetters['countries/getGeoIPCountry'];
                let path = '/app/data/plans?country=' + country;
                if(payload && typeof payload.isRegistration !== 'undefined' && payload.isRegistration) {
                    path = '/sign-up/plans?country=' + country;
                }

                return axios.get(path)
                    .then((response) => {
                        if(response.status === 200) {
                            commit(types.SET_PLANS, response.data);
                        } else {
                            this.dispatch('messages/handleXHRFailureMessages', {response: response});
                        }
                    })
                    .catch((error) => {
                        reportAxiosError(error);
                        this.dispatch('messages/handleXHRFailureMessages', error);
                    });
            });
    },

    setAccountPlan ({ commit }, payload) {
        commit(types.SET_ACCOUNT_PLAN, payload);
    }

};

const mutations = {

    [types.SET_PLANS] (state, items) {
        state.plans = items;
    },

    [types.SET_ACCOUNT_PLAN] (state, item) {
        state.accountPlan = item;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}